import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import App from "./App";
import { store } from "./app/store";
import { Provider } from "react-redux";
import { MathJaxContext } from "better-react-mathjax";

import ErrorBoundary from "./components/ErrorBoundary";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <MathJaxContext>
      <ErrorBoundary fallback="App Error">
        <Router>
          <Routes>
            <Route path="/*" element={<App />} />
          </Routes>
        </Router>
      </ErrorBoundary>
    </MathJaxContext>
  </Provider>
);
/*
<React.StrictMode>
<Provider store={store}>
  <ErrorBoundary fallback="App Error">
    <Router>
      <Routes>
        <Route path="/*" element={<App />} />
      </Routes>
    </Router>
  </ErrorBoundary>
</Provider>
</React.StrictMode>
*/
